import { Action } from '@ngrx/store';
import { MenuOptionsActions } from './options.actions';

export const initialOptionsState: {[key: string]: Array<string>} = {};

export function optionsReducer (state: {[key: string]: Array<string>} = initialOptionsState, action: any) {
    switch (action.type) {
        case MenuOptionsActions.ADD:
            return {...state,  ...action.payload };
        default:
        return state;
    }
};
